<div class="nav-container" style="background-color:#1a212a">
  <ng-container *ngIf="admin">
    <mat-accordion class="user-menu-panel" displayMode="flat">
      <mat-expansion-panel class="mat-elevation-z">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px" style="background-color:#1a212a"
          class="specific-class">
          <mat-panel-title>
            <mat-list class="user-menu-header">
              <mat-list-item style="background-color:#1a212a">
                <img matListAvatar src="/assets/images/Default-Person.png" alt="">
                <a class="paddingl">
                  <span matLine class="wtext">{{ admin.name }}</span>
                  <span matLine class="wtext">{{ admin.role }}</span>
                </a>
              </mat-list-item>
            </mat-list>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-nav-list style="background-color:#28303C">
          <mat-list-item (click)="openEditUser()">
            <mat-icon style="margin-left: 5px">person</mat-icon>
            <a class="wtext paddingl">แก้ไขข้อมูลส่วนบุคคล</a>
          </mat-list-item>
          <mat-list-item (click)="openChangePassword()">
            <mat-icon style="margin-left: 5px" color="white">lock</mat-icon>
            <a class="wtext paddingl">เปลี่ยนรหัสผ่าน</a>
          </mat-list-item>
          <mat-list-item (click)="signOut()">
            <mat-icon style="margin-left: 5px">power_settings_new</mat-icon>
            <a class="wtext paddingl">ออกจากระบบ</a>
          </mat-list-item>
        </mat-nav-list>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>

  <mat-divider></mat-divider>
  <mat-nav-list style="background-color:#28303C">
    <h3 matSubheader class="wtext headerBG">โรงพยาบาล</h3>
    <ng-container  *ngIf="admin && admin.role==='super-admin'">
      <a mat-list-item (click)="openDialog()">
        <mat-icon matListIcon color="white">add</mat-icon>
        <span class="wtext">เพิ่มโรงพยาบาล</span>
      </a>
    </ng-container>

    <ng-container *ngFor="let site of sites | keyvalue: keyDescOrder">
      <a class="nav-link" mat-list-item [routerLink]="['/', Url.Site, site.value.id]" [class.active_dark]="site.value.id === selectedSiteId">
        <!-- <mat-icon matListIcon color="primary">local_hospital</mat-icon> -->
        <img matListAvatar src="{{site.value.logoUrl}}" alt="logo">
        <div>
          <span class="wtext paddingl">{{site.value.name}}</span>
          <br>
          <span class="wtext small-text paddingl">ID: {{site.value.displayId}} | Order: {{site.value.displayOrder || '-'}}</span>
        </div>

      </a>
    </ng-container>
  </mat-nav-list>


  <div class="flex-spacer"></div>
  <!--
  <mat-nav-list>
    <mat-list-item >

        <img matListAvatar
        src='https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light'
        alt="">
      <a >
        <span matLine>Firstname Lastname</span>
        <span matLine>root</span>
      </a>
      <i class="material-icons" [matMenuTriggerFor]="menu">
          keyboard_arrow_down
          </i>


    </mat-list-item>
  </mat-nav-list> -->
  <!--
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="changePasswordFn()">Charge Password</button>
        <button mat-menu-item (click)="signOutFn()">Sign Out</button>
      </mat-menu> -->
</div>
